import cx from 'classnames';
import React from 'react';

import colors from 'utils/colors';

import * as Elements from './Elements';
import { IconProps } from './interfaces';

const d1 =
  'M13.772,4.397L14.344,3.825C15.218,2.952 15.218,1.53 14.344,0.657C13.498,-0.189 12.023,-0.189 11.176,0.657L10.599,1.234L13.772,4.397Z';
const d2 =
  'M12.892,5.499L5.926,12.465C5.867,12.524 5.801,12.572 5.728,12.609L1.106,14.919C0.812,15.067 0.456,15.008 0.224,14.776C-0.008,14.544 -0.067,14.188 0.081,13.894L2.391,9.273C2.428,9.199 2.476,9.133 2.535,9.074L9.501,2.108L12.892,5.499Z';

const Change: React.FC<IconProps> = ({
  className = '',
  clipRule = 'evenodd',
  fill = colors.blueGrey,
  fillRule = 'evenodd',
  strokeLinejoin = 'round',
  strokeMiterlimit = '2',
  viewBox = '0 0 15 15',
  focusable
}) => {
  return (
    <Elements.Svg
      className={cx({ [className]: !!className })}
      clipRule={clipRule}
      fill={fill}
      fillRule={fillRule}
      strokeLinejoin={strokeLinejoin}
      strokeMiterlimit={strokeMiterlimit}
      viewBox={viewBox}
      focusable={!!focusable}
      aria-hidden={!focusable}>
      <Elements.Path d={d1} />
      <Elements.Path d={d2} />
    </Elements.Svg>
  );
};

export default Change;
